
	import { Options, Vue } from 'vue-class-component'
	import ChatWindow, { Message, Room, StringNumber } from 'vue-advanced-chat'
	import Talking from '../components/room/Talking.vue'
	import 'vue-advanced-chat/dist/vue-advanced-chat.css'

	@Options({
		components: {
			ChatWindow,
			Talking
		}
	})
	export default class RoomView extends Vue {
		higumaAvator = require('../assets/images/higuma-icon.png')
		rooms: Room[] = [
			{
				roomId: '123',
				roomName: 'ひぐまさん',
				avatar: this.higumaAvator,
				users: [
					{
						_id: 'higuma',
						username: 'ひぐまさん',
						avatar: '',
						status: { state: 'online', lastChanged: '' }
					}
				]
			}
		]
		messages: Message[] = []

		isTalking = false
		talkingType: 'new' | 'additional' = 'new'
		searchKeywords: string[] = []

		async mounted() {
			await this.pushNewMessage({
				content: this.pickMessage([
					'毎日お疲れやで\nだれも聞いてないから、ちょっと愚痴ってみ',
					'毎日つかれるよね\n最近ためこんでない？\nひぐまでよかったら聞くよ'
				]),
				senderId: 'higuma',
				avatar: this.higumaAvator
			})
			await this.pushTalkButton()
		}

		async pushTalkButton(type?: 'new' | 'additional') {
			await this.pushNewMessage({
				_id: 'tell',
				content: '話す',
				senderId: 'higuma'
			})

			setTimeout(() => {
				document.getElementById('tell')?.addEventListener('click', () => {
					this.isTalking = true
					this.talkingType = type || 'new'
				})
			}, 500)
		}

		pushNewMessage(params: {
			content: string
			senderId: 'higuma' | 'me'
			_id?: StringNumber
			avatar?: any
		}) {
			return new Promise((resolve) => {
				setTimeout(() => {
					resolve(
						this.messages.push({
							...params,
							_id: params._id || this.messages.length,
							timestamp: '',
							date: ''
						})
					)
				}, 500)
			})
		}

		pushLinkCard(params: { title: string; href: string; img?: string }) {
			return new Promise((resolve) => {
				setTimeout(() => {
					resolve(
						this.messages.push({
							content: '',
							senderId: 'higuma',
							_id: this.messages.length,
							timestamp: '',
							date: '',
							link: params
						})
					)
				}, 100)
			})
		}

		async stopTalking(e: string, isType?: boolean) {
			this.isTalking = false
			if (this.talkingType === 'new') {
				document.getElementById('tell')?.remove()
				await this.pushNewMessage({
					content: this.pickMessage([
						'ありがとうな！\n大変やったなぁ・・・',
						'話してくれてありがとう'
					]),
					senderId: 'higuma',
					avatar: this.higumaAvator
				})
				await this.userIsTyping()
				const { data } = await this.axios.post('/get-keywords', { text: e })
				const twoKeywords = data.length > 0 ? data.slice(0, 2) : []
				const message =
					twoKeywords.length > 0
						? `${twoKeywords.join('、')}${this.pickMessage([
								'のところ、もう少し詳しく聞かせてや',
								'について、もう少し詳しく教えてくれる？',
								'が気になるなぁ、何かきっかけがあったの？'
						  ])}`
						: 'もう少し詳しく聞かせてや'
				this.searchKeywords = twoKeywords
				await this.userIsTyping()
				await this.pushNewMessage({
					content: message,
					senderId: 'higuma',
					avatar: this.higumaAvator
				})
				if (isType) {
					this.talkingType = 'additional'
				} else {
					await this.pushTalkButton('additional')
				}
			} else if (this.talkingType === 'additional') {
				document.getElementById('tell')?.remove()
				await this.userIsTyping()
				const { data: keywords }: { data: string[] } = await this.axios.post(
					'/get-keywords',
					{
						text: e
					}
				)
				if (this.searchKeywords.length === 0 && keywords.length === 0) {
					this.searchKeywords = ['わがまま', '遊び', '我慢']
				} else if (
					keywords.length > 0 &&
					!this.searchKeywords.includes(keywords[0])
				) {
					this.searchKeywords.push(keywords[0])
				}
				const {
					data: searchResults
				}: {
					data: {
						results: { title: string; url: string; thumbnail?: string }[]
					}
				} = await this.axios.post('/get-searchresults', {
					keywords: this.searchKeywords
				})
				await this.userIsTyping()
				await this.pushNewMessage({
					content: this.pickMessage([
						'こんな情報があるみたいだよ\n参考になると嬉しいな',
						'同じようなことを思っている人がいるよ\nこういうのはどう？',
						'もしかして悩んでることってこれ？'
					]),
					senderId: 'higuma',
					avatar: this.higumaAvator
				})

				for (const result of searchResults.results) {
					await this.pushLinkCard({
						title: result.title,
						href: result.url,
						img: result.thumbnail
					})
				}

				this.closing()
			}
		}

		async closing() {
			await this.pushNewMessage({
				content: this.pickMessage([
					'ちょっとは力になれたかな\nまだ話したいことはある？聞くよ',
					'使える情報だったらいいなぁ\n話したりない？聞くよ'
				]),
				senderId: 'higuma',
				avatar: this.higumaAvator
			})
			await this.pushTalkButton('new')
		}

		userIsTyping() {
			return new Promise((resolve) => {
				const lastMessage = this.messages.slice(-1)[0]
				if (lastMessage._id === 'isTyping') {
					setTimeout(() => {
						resolve(this.messages.splice(-1, 1))
					}, 100)
				} else {
					setTimeout(() => {
						resolve(
							this.messages.push({
								senderId: 'higuma',
								content: '入力中・・・',
								_id: 'isTyping',
								timestamp: '',
								date: ''
							})
						)
					}, 100)
				}
			})
		}

		pickMessage(messageList: string[]) {
			return messageList[Math.floor(Math.random() * messageList.length)]
		}

		onSendMessage(message: Message) {
			this.stopTalking(message.content, true)
		}
	}
